import { CheckRounded } from '@mui/icons-material';
import { Tooltip } from '@mui/material';

interface MetadataFieldMappingStateIndicatorProps {
  isLinked: boolean;
}

export const MetadataFieldMappingStateIndicator = ({
  isLinked,
}: MetadataFieldMappingStateIndicatorProps) => {
  if (isLinked) {
    return (
      <Tooltip title="Linked" arrow placement="top">
        <CheckRounded
          sx={{
            color: 'success.light',
          }}
        />
      </Tooltip>
    );
  }

  return null;
};
